import {jwtDecode} from "jwt-decode";

const UserService = {
    data: () => {
        const authToken = localStorage.getItem("token");
        if (!authToken) {
            return {};
        }
        try {
            const data = jwtDecode(authToken);

            return {
                username:data?.user?.username,
                role: data?.user?.role,
                _id: data?.user?._id
            };

        } catch (err) {        
            return {};
        }
    }
};

export default UserService;
